import React from 'react';
import styles from './index.module.css';
import NotFoundIcon from '../../../src/assets/images/icons/404@3x.png';

const NotFound = () => {
  return (
    <div className={`main-card`}>
      <div className={styles.mainDiv}>
        <img src={NotFoundIcon} alt='NotFoundIcon' className={styles.notFoundImage} />
        <p>Page Not Found</p>
        The page you are looking for <br />doesn’t exit or has been moved
      </div>
    </div>
  );
};

export default NotFound;